import React, { useCallback } from 'react';
import { EntityTypeType } from '~/components/Admin';
import { AdminServiceEvents, ServicesContext } from '~/services';

export interface UpdateUserRoleDataType {
    organization_roles?: string[];
    market_roles?: string[];
    macl_roles?: string[];
    markets?: { id: number }[];
}
export const useUpdateUserRole = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const updateUserRole = useCallback(
        async (id: number, data: UpdateUserRoleDataType, entityType: EntityTypeType) => {
            const response = await services.api.call({
                method: 'put',
                url: `/api/${entityType}-users/${id}`,
                data,
            });
            services.events.publish(events[`user_${entityType}_updated`], response.data);
        },
        [services.api, services.events, events]
    );

    return updateUserRole;
};
